import ArtworkCredit from './ArtworkCredit';
import ArtworkSection from './ArtworkSection';

const aboutImage = {
    jpg: '/art/luminism/newburyport-meadows-heade-1920.jpg',
    srcSet: [
        '/art/luminism/newburyport-meadows-heade-1280.jpg 1280w',
        '/art/luminism/newburyport-meadows-heade-1920.jpg 1920w',
    ].join(', '),
};

function AboutSection() {
    return (
        <ArtworkSection id="about" className="content-slide" image={aboutImage}>
            <div className="slide-copy">
                <p className="section-name">About</p>
                <h2>Building products across mobile, large-scale systems, and AI.</h2>
                <p className="supporting-line">Meta · Instagram iOS · Purdue Computer Science, 2025</p>
                <div className="about-links">
                    <a className="text-link" href="/AdityaPatelResume.pdf">Résumé ↗</a>
                    <a className="text-link" href="https://github.com/adityapatel-sudo"
                        target="_blank" rel="noreferrer">GitHub ↗</a>
                    <a className="text-link" href="https://www.linkedin.com/in/aditpate"
                        target="_blank" rel="noreferrer">LinkedIn ↗</a>
                </div>
            </div>
            <ArtworkCredit>
                Martin Johnson Heade · <cite>Newburyport Meadows</cite> · ca. 1876–81
            </ArtworkCredit>
        </ArtworkSection>
    );
}

export default AboutSection;
